import appLanguage from './atom';
import { getLanguage } from './selector';

export { getLanguage };
export default appLanguage;
